"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _lodash = _interopRequireDefault(require("lodash"));

var _ampApi = require("@amplify/amp-api");

var _realtimeService = _interopRequireDefault(require("./realtimeService"));

var _constants = require("../shared/constants");

var _logger = _interopRequireDefault(require("../utils/logger"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var userStorageErrorHandler = function userStorageErrorHandler(error, userKey, storagePrefix) {
  _logger.default.error("Failed fetching user storage for ".concat(userKey, " at ").concat(storagePrefix), error.message);

  return {
    userKey: userKey,
    storagePrefix: storagePrefix,
    responses: {}
  };
};

var fetchBulkStorageSaves = function fetchBulkStorageSaves() {
  var userKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var storagePrefixes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var fetchParams = userKeys.reduce(function (allParams, userKey) {
    var params = storagePrefixes.map(function (storagePrefix) {
      return [userKey, storagePrefix];
    });
    allParams = allParams.concat(params);
    return allParams;
  }, []);
  var storageDataPromises = fetchParams.map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        userKey = _ref2[0],
        storagePrefix = _ref2[1];

    return (0, _ampApi.fetchFromStorageByPrefix)(userKey, storagePrefix).then(function (responses) {
      return {
        userKey: userKey,
        storagePrefix: storagePrefix,
        responses: responses
      };
    }).catch(function (error) {
      return userStorageErrorHandler(error, userKey, storagePrefix);
    });
  });
  return Promise.all(_lodash.default.flatten(storageDataPromises));
};

var UserStorageNotificationService = /*#__PURE__*/function () {
  function UserStorageNotificationService() {
    (0, _classCallCheck2.default)(this, UserStorageNotificationService);
  }

  (0, _createClass2.default)(UserStorageNotificationService, [{
    key: "addListener",
    value: function () {
      var _addListener = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(classKey, userKeys, storagePrefixes, callback) {
        var initialData, batchedNotifications, batchTimeoutId, clearBatch, notificationCallback;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchBulkStorageSaves(userKeys, storagePrefixes);

              case 2:
                initialData = _context2.sent;
                callback(initialData); // Since storage service saves occur frequently, like autosaves, we batch these requests.

                batchedNotifications = [];
                batchTimeoutId = null;

                clearBatch = /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                    var notificationsToClear, responseUpdates, combinedUpdates;
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            notificationsToClear = batchedNotifications;
                            batchedNotifications = [];
                            batchTimeoutId = null;
                            _context.next = 5;
                            return Promise.all(notificationsToClear.map(function (_ref4) {
                              var userKey = _ref4.userKey,
                                  storagePrefix = _ref4.storagePrefix,
                                  fileKey = _ref4.fileKey;
                              return (0, _ampApi.fetchFromStorage)(userKey, storagePrefix, fileKey).then(function (response) {
                                // fetchFromStorage returns only the stored data, not the fileKey.
                                // To match the format of the other fetch call, we mimic the return format
                                // by keying the response data by the associated fileKey.
                                var responses = (0, _defineProperty2.default)({}, fileKey, JSON.stringify(response));
                                return {
                                  userKey: userKey,
                                  storagePrefix: storagePrefix,
                                  responses: responses
                                };
                              }).catch(function (error) {
                                return userStorageErrorHandler(error, userKey, storagePrefix);
                              });
                            }));

                          case 5:
                            responseUpdates = _context.sent;
                            // combine any overlaps in userKey, storagePrefix records
                            // this makes the callback format easier to apply and more in line with the initial data call
                            combinedUpdates = [];
                            responseUpdates.forEach(function (update) {
                              var existingEntry = combinedUpdates.find(function (_ref5) {
                                var userKey = _ref5.userKey,
                                    storagePrefix = _ref5.storagePrefix;
                                return update.userKey === userKey && update.storagePrefix === storagePrefix;
                              });

                              if (existingEntry) {
                                existingEntry.responses = _objectSpread(_objectSpread({}, existingEntry.responses), update.responses);
                              } else {
                                combinedUpdates.push(update);
                              }
                            });
                            callback(combinedUpdates);

                          case 9:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function clearBatch() {
                    return _ref3.apply(this, arguments);
                  };
                }();

                notificationCallback = function notificationCallback(channel) {
                  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                  var publisher = arguments.length > 2 ? arguments[2] : undefined;
                  if (channel !== classKey || !userKeys.includes(publisher)) return;
                  if (!payload.storagePrefix || !storagePrefixes.includes(payload.storagePrefix)) return;
                  if (!payload.fileKeys && !payload.fileKey) return; // notifications with a single fileKey or an array of fileKeys are supported

                  var fileKeys = payload.fileKeys ? payload.fileKeys : [payload.fileKey];
                  fileKeys.forEach(function (fk) {
                    var found = batchedNotifications.find(function (_ref6) {
                      var userKey = _ref6.userKey,
                          storagePrefix = _ref6.storagePrefix,
                          fileKey = _ref6.fileKey;
                      return userKey === publisher && storagePrefix === payload.storagePrefix && fileKey === fk;
                    });

                    if (!found) {
                      batchedNotifications.push({
                        userKey: publisher,
                        storagePrefix: payload.storagePrefix,
                        fileKey: fk
                      });
                    }
                  });

                  if (!batchTimeoutId) {
                    batchTimeoutId = setTimeout(clearBatch, _constants.USER_STORAGE_BATCH_TIME);
                  }
                };

                _realtimeService.default.addEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_STORAGE_SAVE, notificationCallback, callback);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function addListener(_x, _x2, _x3, _x4) {
        return _addListener.apply(this, arguments);
      }

      return addListener;
    }()
  }, {
    key: "removeListener",
    value: function removeListener(callback) {
      _realtimeService.default.removeEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_STORAGE_SAVE, callback);
    }
  }, {
    key: "publishNotification",
    value: function publishNotification(classKey, storagePrefix, fileKeys, recipient) {
      if (!Array.isArray(fileKeys)) {
        fileKeys = [fileKeys];
      }

      var payload = {
        storagePrefix: storagePrefix,
        fileKeys: fileKeys
      };
      return _realtimeService.default.publish(classKey, _constants.STUDENT_RECORD_TYPES.STUDENT_STORAGE_SAVE, payload, recipient);
    }
  }]);
  return UserStorageNotificationService;
}();

var _default = new UserStorageNotificationService();

exports.default = _default;
//# sourceMappingURL=userStorageNotificationService.js.map